module.exports = __webpack_public_path__ + "static/Willy_Ahmad_Syafiq_-_Product_Designer-8a08002a9001b04b3f19a51eac252450.pdf";